<app-modal-frame
  [headerText]="CONST.HEADER"
  [rightButton]="{
    type: BUTTON_TYPES.NONE,
  }"
  [leftButton]="{
    type: BUTTON_TYPES.NONE,
  }"
  (emitExit)="closePopup()"
>
  <form [formGroup]="uldForm" class="modal-container">
    <ion-row>
      <!-- Sort Date -->
      <ion-col size="auto" class="custom-col">
        <div class="md-control text-box-container disabled-input-box-container">
          <app-form-input-field
            [label]="CONST.SORT_DATE"
            [formControlName]="IDS.SORT_DATE"
            [placeholder]="CONST.SORT_DATE"
            [disabled]="true"
            [required]="false"
          ></app-form-input-field>
        </div>
      </ion-col>

      <!-- Sort Code -->
      <ion-col size="auto">
        <div class="md-control text-box-container disabled-input-box-container">
          <app-form-input-field
            [label]="CONST.SORT"
            [formControlName]="IDS.SORT"
            [placeholder]="CONST.SORT"
            [disabled]="true"
            [required]="false"
          ></app-form-input-field>
        </div>
      </ion-col>
    </ion-row>
    <ion-row class="mt-12">
      <ion-col size="auto" class="custom-col">
        <div class="md-control text-box-container disabled-input-box-container">
          @let isLoadChart =
            (_data?.sealNumber && _data?.movement) ||
            (_data?.equipment?.sealNumber && _data?.equipment?.movement) ||
            isInternationalLoad;
          <app-form-input-field
            [label]="isLoadChart ? CONST.LOAD_CHART : CONST.LOAD_NAME"
            [formControlName]="isLoadChart ? IDS.LOAD_CHART : IDS.LOAD_NAME"
            [placeholder]="isLoadChart ? CONST.LOAD_CHART : CONST.LOAD_NAME"
            [disabled]="true"
            [required]="false"
          ></app-form-input-field>
        </div>
      </ion-col>
      <ion-col size="auto" class="custom-col">
        <div
          class="formmd-control text-box-container disabled-input-box-container"
        >
          <app-form-input-field
            [label]="CONST.EQUIPMENT_NUMBER"
            [formControlName]="IDS.EQUIPMENT_NUMBER"
            [placeholder]="CONST.NUMBER_PLACEHOLDER"
            [disabled]="true"
            [required]="false"
          ></app-form-input-field>
        </div>
      </ion-col>
    </ion-row>
    @if (
      (_data.sealNumber && _data.movement) ||
      (_data?.equipment?.sealNumber && _data?.equipment?.movement) ||
      isInternationalLoad
    ) {
      <ion-row class="mt-12">
        <ion-col size="auto" class="custom-col">
          <div
            class="md-control text-box-container disabled-input-box-container"
          >
            <app-form-input-field
              [label]="CONST.MOVEMENT"
              [formControlName]="IDS.MOVEMENT"
              [placeholder]="CONST.MOVEMENT"
              [disabled]="true"
              [required]="false"
            ></app-form-input-field>
          </div>
        </ion-col>
        <ion-col size="auto" class="custom-col">
          <div
            class="md-control text-box-container disabled-input-box-container"
          >
            <app-form-input-field
              [label]="CONST.SEAL_CONTROL"
              [formControlName]="IDS.SEAL_CONTROL"
              [placeholder]="CONST.SEAL_CONTROL_PLACEHOLDER"
              [disabled]="true"
              [required]="false"
            ></app-form-input-field>
          </div>
        </ion-col>
      </ion-row>
    }
    <ion-row>
      <ion-col size="auto">
        <div class="md-control lg-select common-select">
          <app-form-select
            [label]="CONST.ACTION"
            [options]="ACTION_LIST"
            [formControlName]="IDS.ACTION"
            [placeholder]="CONST.SELECT"
            [isAppendToBody]="true"
            [isSearchable]="false"
          >
          </app-form-select>
        </div>
      </ion-col>
    </ion-row>
    @if (_data.outboundScan) {
      <ion-col size="12" class="hazmat-dryice-container">
        <div class="checkbox-group">
          <ion-item lines="none" class="item">
            <ion-checkbox
              slot="start"
              class="checkbox-btn"
              formControlName="hazmat"
              (ionChange)="onHazmatChange($event.detail.checked)"
              ngDefaultControl
            ></ion-checkbox>
            <ion-label class="btn-label">{{ CONST.HAZMAT }}</ion-label>
          </ion-item>

          <ion-item lines="none" class="item">
            <ion-checkbox
              slot="start"
              class="checkbox-btn"
              formControlName="dryIce"
              (ionChange)="onDryIceChange($event.detail.checked)"
              ngDefaultControl
            ></ion-checkbox>
            <ion-label class="btn-label">{{ CONST.DRY_ICE }}</ion-label>
          </ion-item>
          @if (uldForm.get("dryIce")?.value) {
            <div class="dry-ice-details">
              <app-form-input-field
                [label]="CONST.AMOUNT"
                formControlName="dryIceAmountOne"
                [maxLength]="3"
                [required]="true"
                class="dry-ice-amount-one"
                (keypress)="
                  commonUtils.preventSpecialCharacters(
                    $event,
                    SpecialCharacters.NUMBER_ONLY
                  )
                "
              ></app-form-input-field>
              .
              <app-form-input-field
                [maxLength]="2"
                formControlName="dryIceAmountTwo"
                [required]="false"
                class="dry-ice-amount-two"
                (keypress)="
                  commonUtils.preventSpecialCharacters(
                    $event,
                    SpecialCharacters.NUMBER_ONLY
                  )
                "
              ></app-form-input-field>

              <app-form-select
                [label]="CONST.UNIT_OF_MEASURE"
                [options]="UNITS"
                formControlName="unitOfMeasure"
                [required]="true"
              ></app-form-select>
            </div>
          }
        </div>
      </ion-col>
    }

    <ion-row>
      <ion-col size="auto" class="custom-col">
        <div class="tracking-number-container">
          <ion-item
            class="tracking-number-item"
            lines="none"
            [ngClass]="{
              'has-error':
                uldForm.get('trackingNumbers')?.invalid &&
                uldForm.get('trackingNumbers')?.value &&
                (uldForm.get('trackingNumbers')?.touched ||
                  uldForm.get('trackingNumbers')?.dirty),
            }"
          >
            <ion-textarea
              formControlName="trackingNumbers"
              class="form-textarea"
              type="text"
              maxlength="18"
              [placeholder]="CONST.TRACKING_NUMBER_PLACEHOLDER"
              (keypress)="commonUtils.preventSpecialCharacters($event)"
              [autoGrow]="true"
              cols="1"
              appUppercase
            ></ion-textarea>
            <ion-button
              slot="end"
              fill="clear"
              class="upload-btn"
              (click)="fileUpload()"
            >
              <ion-icon [src]="SRC.UPLOAD" class="btn-icon"></ion-icon>
              <span class="btn-text"> {{ CONST.FILE_UPLOAD }} </span>
            </ion-button>
          </ion-item>
          <div class="action-bar">
            <ion-button
              class="submit-btn"
              [disabled]="uldForm.invalid"
              (click)="submit()"
            >
              {{ CONST.SUBMIT }}
            </ion-button>
          </div>
        </div>
        @if (
          uldForm.get("trackingNumbers")?.invalid &&
          uldForm.get("trackingNumbers")?.value &&
          (uldForm.get("trackingNumbers")?.touched ||
            uldForm.get("trackingNumbers")?.dirty)
        ) {
          <p class="error-msg">
            {{ CONST.INVALID_TRACKING_NUMBER }}
          </p>
        }
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="auto" class="custom-col">
        <div class="md-control uld-count-items">
          <p class="count">{{ CONST.ULD_COUNT }}: {{ uldCount }}</p>
          <p class="count">{{ CONST.LOOSE_COUNT }}: {{ looseCount }}</p>
        </div>
      </ion-col>
    </ion-row>
    @if (tableData.length > 0) {
      <ion-row>
        <ion-col>
          <div
            class="uld-count-table-container"
            [ngClass]="{ 'is-visible': !!tableData.length }"
          >
            <app-table
              [maxHeight]="10"
              [displayedColumns]="displayedColumn"
              [columns]="COLUMN_CONFIG"
              [data]="tableData"
              #childTable
            >
            </app-table>
          </div>
        </ion-col>
      </ion-row>
    }
    <div class="footer">
      <ion-button class="next-btn footer-btn" (click)="closePopup()">
        {{ CONST.DONE }}
      </ion-button>
    </div>
  </form>
</app-modal-frame>
